import type * as THREE from 'three'

export interface TextureImageLike {
  width: number
  height: number
  data?: ArrayLike<number> | null
  close?: () => void
}

/**
 * 读取 Three.js Texture 的运行时图像背板。
 *
 * Three r185 将基础 `Texture.image` 收紧为 `unknown`；3DGS reader 实际只接受带宽高的
 * ImageBitmap、HTMLImageElement、Canvas 或 DataTexture image，因此在边界统一验证并收窄。
 */
export function getTextureImage(texture: THREE.Texture): TextureImageLike {
  const image = texture.image
  if (
    !image ||
    typeof image !== 'object' ||
    !('width' in image) ||
    !('height' in image) ||
    typeof image.width !== 'number' ||
    typeof image.height !== 'number'
  ) {
    throw new Error(`Texture "${texture.name}" 缺少有效的 image.width/image.height`)
  }
  return image as TextureImageLike
}
